


























import Vue from "vue";
import { Header } from "@/components/MyTable.vue";
import { ListHeader } from "@/components/MyListCard.vue";

const ConfigListHeader: Header[] = [
  { title: "Key", key: "key", width: 200 },
  { title: "Value", key: "value", minWidth: 400 }
];
const infoHeader: ListHeader[] = [
  { title: "配置名称", key: "name" },
  { title: "配置描述", key: "description" },
  { title: "创建人", key: "createBy" },
  { title: "创建时间", key: "createTime" }
];
export default Vue.extend({
  name: "Overview",
  props: { data: { type: Object } },
  data() {
    return {
      ConfigListHeader,
      infoHeader,
      activeNames: []
    };
  }
});
